import axios from 'axios';
import React, { Component } from 'react'
import swal from 'sweetalert';
//import Cookies from 'universal-cookie';
import $ from 'jquery';
import Cookies from 'universal-cookie';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ApiUrl } from '../../services/ApiRest';
import { Table, Button, Container, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup } from 'reactstrap';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import './matricula.css';

const cookie = new Cookies();
const baseUrlListarperiodosmatriculadosest = ApiUrl + "listarperiodosmatriculadosest" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const mostrarasignaturasmatriperioestdUrl = ApiUrl + "mostrarasignaturasmatriperiodest" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlDatosEst = ApiUrl + "datosestudiante" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListarDocentesAsignatura = ApiUrl + "listdocentesdeasignatura" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListarPreguntasUltEval = ApiUrl + "obtenerpreguntasevalactiva" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlGuardarRespuestasEst = ApiUrl + "guardarrespuestasestudiante" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListarPeriodosActivos = ApiUrl + "listarperiodosactivos" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
//listar estudiantes matriculados

export default class ListarAsignaturasMatricu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            estudiantes: [],
            listperiodosmatestud: [],
            listasignaturasmatestudperiod: [],
            idCarrera: "",
            nivelEstu: "",
            carrera: [],
            carreramat: [],
            form1: {

            },
            nombreDocente: "",
            fechinicioasig: "",
            fechfinasig: "",
            detall: "",
            ruta: "",
            modalEvaluacionDocente: false,
            docentesAsignatura: [],
            docenteSeleccionado: "",
            asignaturaSeleccionada: null,
            preguntasEvaluacion: [],
            respuestasEvaluacion: {},
            periodosActivos: [],
            periodosActivosIds: [],
        };
        this.handleChange = this.handleChange.bind(this);
        this.escFunction = this.escFunction.bind(this);
    }

    escFunction(event) {
        if (event.key === "Escape") {
            this.setState({ modalDetalleCurso: false });
        }
    }

    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })

    }

    /***********************SELECCIONA  UNA CARRERA-***** */
    handleChangeCarrera = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        //listar periodos en los que el estudiante se ha matriculado
        axios
            .post(baseUrlListarperiodosmatriculadosest, {
                idEstudiantein:   cookie.get("idEstudiante"),
                idCarrerae: this.state.idCarrera,
            })
            .then(response => {
                const listperiodosmatestud = response.data.data;
                this.setState({ listperiodosmatestud });
                const cant = listperiodosmatestud.length;
                if (listperiodosmatestud == 0) {

                }
            })
    }


    /*********PERIODO**** */

    handleChangePeriodo = async (e) => {
        await this.setState({ [e.target.name]: parseInt(e.target.value, 10) });
        this.cargarAsignaturasMatriculadas();
    };

    cargarAsignaturasMatriculadas = () => {
        axios.post(mostrarasignaturasmatriperioestdUrl, {
            idEstudiante: cookie.get("idEstudiante"),
            idCarrerae: this.state.idCarrera,
            nivelEstue: this.state.nivelEstu,
            idPeriodoM: this.state.idPeriodoMatri
        })
            .then(response => {
                const listasignaturasmatestudperiod = response.data.data;
                if (listasignaturasmatestudperiod.length > 0) {
                    this.setState({ listasignaturasmatestudperiod });
                }
            })
            .catch(error => {
                console.error("Error al cargar asignaturas:", error);
            });
    };

    cargarPeriodosActivos = () => {
        axios.get(urlListarPeriodosActivos)
            .then(response => {
                const periodos = response.data.data;
                const periodosIds = periodos.map(p => p.id_periodo_academico);
                this.setState({
                    periodosActivos: periodos,
                    periodosActivosIds: periodosIds
                });
            })
            .catch(error => {
                console.error("Error al cargar periodos activos:", error);
                swal("Error", "No se pudieron cargar los periodos activos", "error");
            });
    };

    esEvaluableAhora = (asignatura) => {
        const { periodosActivosIds } = this.state;

        return (
            asignatura.estado_eval !== "Evaluado" &&
            periodosActivosIds.includes(this.state.idPeriodoMatri)
        );
    };

    //listar estudiantes matriculados 
    componentDidMount = async (e) => {
        document.addEventListener("keydown", this.escFunction, true);
        axios
            .post(urlDatosEst, {
                idEstudiante: cookie.get("idEstudiante"),
            })
            .then(response => {
                ;
                this.setState({ carreramat: response.data.data });
                this.cargarPeriodosActivos();
            })
    }

    //Detalle del curso
    ocultarModDetalleCurso = () => {
        this.setState({ modalDetalleCurso: false });
    }

    convertirDosDecimales = (nota) => {
        return (nota.toFixed(2))
    }

    abrirModalEvaluacion = (asignatura) => {
        // Limpiar datos antiguos antes de mostrar el modal
        this.setState({
            modalEvaluacionDocente: true,
            asignaturaSeleccionada: asignatura,
            docentesAsignatura: [],
            docenteSeleccionado: null, // 👈 Resetear selección previa
            preguntasEvaluacion: [],
            respuestasEvaluacion: {}
        });

        axios.post(urlListarDocentesAsignatura, {
            id_asignatura: asignatura.id_asignatura,
            id_periodo: this.state.idPeriodoMatri,
            paralelo: asignatura.paralelo
        })
            .then(response => {
                this.setState({ docentesAsignatura: response.data.data });
            })
            .catch(error => {
                console.error("Error al cargar docentes", error);
                swal("Error", "No se pudieron cargar los docentes", "error");
            });
    };

    handleSeleccionDocente = (event) => {
        const docenteId = parseInt(event.target.value, 10); // ⚠️ Conversión a entero
        this.setState({ docenteSeleccionado: docenteId, preguntasEvaluacion: [], respuestasEvaluacion: {} });

        axios.get(urlListarPreguntasUltEval)
            .then(response => {
                const preguntas = response.data.preguntas || [];
                this.setState({ preguntasEvaluacion: preguntas });
            })
            .catch(error => {
                console.error('Error al cargar preguntas:', error);
            });
    };

    cerrarModalEvaluacion = () => {
        this.setState({
            modalEvaluacionDocente: false,
            docenteSeleccionado: null,
            preguntasEvaluacion: [],
            respuestasEvaluacion: {}
        });
    };

    handleCambioRespuesta = (preguntaId, valor) => {
        this.setState((prevState) => ({
            respuestasEvaluacion: {
                ...prevState.respuestasEvaluacion,
                [preguntaId]: String(valor)
            }
        }));
    };

    validarRespuestasCompletas = () => {
        const { preguntasEvaluacion, respuestasEvaluacion } = this.state;

        for (const pregunta of preguntasEvaluacion) {
            const respuesta = respuestasEvaluacion[pregunta.id];
            if (pregunta.tipo === 'Opción Múltiple' && (respuesta === undefined || respuesta === '')) {
                return false; // Falta respuesta de opción múltiple
            }

            if ((pregunta.tipo === 'Abierta' || pregunta.tipo === 'abierta') && (!respuesta || respuesta.trim() === '')) {
                return false; // Falta respuesta de pregunta abierta
            }
        }

        return true;
    };

    enviarRespuestasEvaluacion = () => {
        const {
            respuestasEvaluacion,
            preguntasEvaluacion,
            asignaturaSeleccionada,
            docenteSeleccionado // ID del docente elegido
        } = this.state;

        const respuestasFormateadas = preguntasEvaluacion.map((pregunta) => {
            const valorRespuesta = respuestasEvaluacion[pregunta.id];
            const esPreguntaAbierta = pregunta.tipo === 'Abierta';
            let opcionSeleccionada = null;

            if (!esPreguntaAbierta && pregunta.opciones) {
                const match = pregunta.opciones.find(op => String(op.valor) === String(valorRespuesta));
                opcionSeleccionada = match ? match.id : null;
            }

            return {
                pregunta_id: pregunta.id,
                opcion_respuesta_id: opcionSeleccionada,
                respuesta_texto: esPreguntaAbierta ? valorRespuesta : null
            };
        });

        const payload = {
            respuestas: respuestasFormateadas,
            matricula_asignatura_id: asignaturaSeleccionada.id_matricula_asignatura,
            administrativo_id: docenteSeleccionado
        };

        axios.post(urlGuardarRespuestasEst, payload)
            .then((res) => {
                swal("¡Éxito!", "Respuestas enviadas correctamente", "success");
                this.cargarAsignaturasMatriculadas();
                this.cerrarModalEvaluacion();
            })
            .catch((error) => {
                console.error("Error al guardar respuestas:", error);
                swal("Error", "Ocurrió un problema al enviar las respuestas", "error");
            });
    };
    render() {
        return (
            <div className="row animate__animated animate__fadeIn">
                <div className="card p-3 mb-2 bg-white rounded-4 shadow-sm border-0 mt-5 mt-sm-0">
                    {/* Card header adaptado a la plantilla */}
                    <div className="back-istmas">
                        <i className="fa fa-graduation-cap bounce-custom"></i>
                        <b className="mb-0"> Mis Asignaturas por Periodo</b>
                    </div>
                    <div className="p-3 rounded-3 mt-3">
                        <div className="table-responsive">
                            <div className="row ">
                                <div className="col-12 col-sm-12 col-lg-1 col-xl-4 " >
                                    <div className="mb-3">
                                        <label className="form-label text-azul"><b> <i className="fa fa-graduation-cap"></i> Carrera</b></label>
                                        <select className="form-select form-select-sm" name="idCarrera" value={this.state.idCarrera} onChange={this.handleChangeCarrera}>
                                            <option value="undefined">Seleccione la carrera</option>
                                            {this.state.carreramat.map(person => (
                                                <option key={person.id_carrera} value={person.id_carrera}>{person.descripcion_carrera}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12 col-lg-1 col-xl-4 " >
                                    <div className="mb-3">
                                        <label className="form-label text-azul"><b> <i className="fa fa-calendar"></i> Período</b></label>
                                        <select className="form-select form-select-sm" name="idPeriodoMatri" value={this.state.idPeriodoMatri} onChange={this.handleChangePeriodo}>
                                            <option value="undefined">Seleccione el periódo</option>
                                            {this.state.listperiodosmatestud.map(person => (
                                                <option key={person.id_periodo_academico} value={person.id_periodo_academico}>{person.descripcion_periodo_academico}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <table className="table table-hover table-sm-custom">
                                <thead>
                                    <tr className="text-azul">
                                        <th>Evaluación</th>
                                        <th>Código</th>
                                        <th>Asignatura</th>
                                        <th>#Mat</th>
                                        <th>Nivel</th>
                                        <th>Paralelo</th>
                                        <th>Parcial 1(10)</th>
                                        <th>Parcial 2(10)</th>
                                        <th>Parcial 3(10)</th>
                                        <th>Prom. Parciales(6)</th>
                                        <th>Examen Final(4)</th>
                                        <th>Promedio Acum.(10)</th>
                                        <th>Exam.Susp(10)</th>
                                        <th>Prom. Final(10)</th>
                                        <th>Estado</th>
                                        <th>Asistencia(%)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {console.log(this.state.listasignaturasmatestudperiod)
                                    }
                                    {this.state.listasignaturasmatestudperiod.map(consola => (
                                        <tr className="text-azul" key={consola.id_asignatura}>
                                            <td>
                                                {(() => {

                                                    if (this.esEvaluableAhora(consola)) {
                                                        return (
                                                            <button
                                                                className="btn btn-success btn-sm d-flex align-items-center"
                                                                onClick={() => this.abrirModalEvaluacion(consola)}
                                                            >
                                                                <i className="fa fa-check-circle me-1"></i>
                                                                <span>Evaluar</span>
                                                            </button>
                                                        );
                                                    } else {
                                                        return "Evaluado";
                                                    }
                                                })()}
                                            </td>
                                            <td>{consola.codigo_asignatura}</td>
                                            <td>{consola.descripcion_asignatura}</td>
                                            <td>{consola.tipo_matricula_asignatura}</td>
                                            <td>{consola.nivel_asignatura}</td>
                                            <td>{consola.nombre_paralelo}</td>
                                            <td className={this.esEvaluableAhora(consola) ? "blurred-text" : ""}>
                                                {this.convertirDosDecimales(consola.parcial1)}
                                            </td>
                                            <td className={this.esEvaluableAhora(consola) ? "blurred-text" : ""}>
                                                {this.convertirDosDecimales(consola.parcial2)}
                                            </td>
                                            <td className={this.esEvaluableAhora(consola) ? "blurred-text" : ""}>
                                                {this.convertirDosDecimales(consola.parcial3)}
                                            </td>
                                            <td className={this.esEvaluableAhora(consola) ? "blurred-text" : ""}>
                                                {(() => {

                                                    var suma = consola.parcial1 + consola.parcial2 + consola.parcial3;
                                                    var promparcial = ((suma * 6) / 30);
                                                    promparcial = promparcial.toFixed(2);
                                                    return promparcial;

                                                })()}

                                            </td>
                                            <td className={this.esEvaluableAhora(consola) ? "blurred-text" : ""}>
                                                {(() => {

                                                    var examenfinal = ((consola.examen_final * 4) / 10);
                                                    examenfinal = examenfinal.toFixed(2);
                                                    return examenfinal;

                                                })()}
                                            </td>
                                            <td className={this.esEvaluableAhora(consola) ? "blurred-text" : ""}>
                                                {(() => {

                                                    var suma = consola.parcial1 + consola.parcial2 + consola.parcial3;
                                                    var promparcial = ((suma * 6) / 30);
                                                    var promacum = promparcial + ((consola.examen_final * 4) / 10);
                                                    promacum = promacum.toFixed(2);
                                                    return promacum;

                                                })()}


                                            </td>
                                            <td className={this.esEvaluableAhora(consola) ? "blurred-text" : ""}>
                                                {consola.examen_suspension}
                                            </td>
                                            <td className={this.esEvaluableAhora(consola) ? "blurred-text" : ""}>
                                                {(() => {

                                                    var examenfinal = ((consola.examen_final * 4) / 10);

                                                    var suma = consola.parcial1 + consola.parcial2 + consola.parcial3;
                                                    var promparcial = ((suma * 6) / 30);
                                                    var promacum = promparcial + examenfinal;
                                                    var promediof = promacum.toFixed(2);

                                                    if (promacum >= 7) {
                                                        var promediof = promacum;
                                                        return promacum.toFixed(2);
                                                    }
                                                    else {
                                                        if (((promacum >= 4) && (promacum < 7)) && (consola.examen_suspension == 0)) {
                                                            var promediof = promacum;
                                                            return promacum.toFixed(2);
                                                        }
                                                        else {

                                                            if (((promacum >= 4) && (promacum < 7)) && (consola.examen_suspension > 0)) {
                                                                var promediof = (promacum + consola.examen_suspension) / 2;
                                                                return promediof.toFixed(2);
                                                            }
                                                            else {
                                                                var promediof = promacum;
                                                                return promacum.toFixed(2);
                                                            }
                                                        }
                                                    }

                                                })()}
                                            </td>
                                            <td className={this.esEvaluableAhora(consola) ? "blurred-text" : ""}>
                                                {(() => {
                                                    switch (consola.equivalencia) {
                                                        case 0: return "REPROBADO";
                                                        case 1: return "APROBADO";
                                                        default: return ""
                                                    }

                                                })()}
                                            </td>
                                            <td className={this.esEvaluableAhora(consola) ? "blurred-text" : ""}>
                                                {consola.asistencia}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            {/*Modal de datos de docente-asignatura*/}
                            <Modal isOpen={this.state.modalDetalleCurso} >
                                <ModalHeader>

                                </ModalHeader>
                                <ModalBody>
                                    <FormGroup>

                                        <input name="imagen" type="image" src={this.state.ruta} align="center" alt="fotografia" width='50%'
                                            height='50%' ></input>
                                        <br />
                                        <br />

                                        <div className="mb-3 centrar">
                                            <div className="row ">
                                                <div className="col-12 col-sm-12  col-lg-5 col-xl-5 centrar" >
                                                    <div className="mb-3">
                                                        <b> <label className="form-label">Docente</label> </b>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-lg-5 col-xl-5 centrar" >
                                                    <div className="mb-3">

                                                        {this.state.nombreDocente}

                                                    </div>
                                                </div>
                                            </div>


                                            <div className="row ">
                                                <div className="col-12 col-sm-12  col-lg-5 col-xl-5 centrar" >
                                                    <div className="mb-3">
                                                        <b> <label className="form-label">Fecha Inicio</label> </b>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-lg-5 col-xl-5 centrar" >
                                                    <div className="mb-3">

                                                        {this.state.fechinicioasig}

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row ">
                                                <div className="col-12 col-sm-12  col-lg-5 col-xl-5 centrar" >
                                                    <div className="mb-3">
                                                        <b> <label className="form-label">Fecha Fin</label> </b>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-lg-5 col-xl-5 centrar" >
                                                    <div className="mb-3">

                                                        {this.state.fechfinasig}

                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row ">
                                                <div className="col-12 col-sm-12  col-lg-5 col-xl-5 centrar" >
                                                    <div className="mb-3">
                                                        <b> <label className="form-label">Detalle</label> </b>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-lg-5 col-xl-5 centrar" >
                                                    <div className="mb-3">

                                                        {this.state.detall}

                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </FormGroup>
                                </ModalBody>
                                <ModalFooter>
                                    <button class="btn btn-outline-primary" onClick={this.ocultarModDetalleCurso}>Salir</button>
                                </ModalFooter>
                            </Modal>
                            {/*Modal de datos de evaluación del docente*/}
                            <Modal isOpen={this.state.modalEvaluacionDocente} style={{ minWidth: '50%' }}>
                                <ModalHeader>Evaluar Docente</ModalHeader>
                                <ModalBody className="text-azul" style={{ maxHeight: '75vh', overflowY: 'auto' }}>
                                    <FormGroup>
                                        <select
                                            className="form-select form-select-sm"
                                            value={this.state.docenteSeleccionado || ''}
                                            onChange={this.handleSeleccionDocente}
                                        >
                                            <option value="">Seleccione el docente a evaluar:</option>
                                            {this.state.docentesAsignatura.map((docente) => (
                                                <option key={docente.id_administrativo} value={docente.id_administrativo}>
                                                    {docente.nombres_administrativo} {docente.apellidos_administrativo}
                                                </option>
                                            ))}
                                        </select>
                                    </FormGroup>

                                    {/* Calcular el máximo número de opciones entre todas las preguntas cerradas */}
                                    {(() => {
                                        const preguntasCerradas = this.state.preguntasEvaluacion.filter(p => p.tipo === 'Opción Múltiple');
                                        const maxOpciones = Math.max(...preguntasCerradas.map(p => p.opciones.length));

                                        return preguntasCerradas.length > 0 && (
                                            <div className="mt-4">
                                                <h6>Preguntas de opción múltiple</h6>
                                                <div className="table-responsive">
                                                    <table className="table table-hover table-bordered table-sm-custom">
                                                        <thead className="text-center">
                                                            <tr className="text-azul">
                                                                <th style={{ width: '40%' }}>Pregunta</th>
                                                                {[...Array(maxOpciones)].map((_, idx) => (
                                                                    <th key={idx}>Opción {idx + 1}</th>
                                                                ))}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {preguntasCerradas.map((pregunta, index) => (
                                                                <tr className="text-azul" key={`${pregunta.id}_${this.state.docenteSeleccionado}`}>
                                                                    <td>{index + 1}. {pregunta.pregunta}</td>
                                                                    {[...Array(maxOpciones)].map((_, idx) => {
                                                                        const opcion = pregunta.opciones[idx];
                                                                        return (
                                                                            <td key={idx} className="text-center">
                                                                                {opcion ? (
                                                                                    <>
                                                                                        <input
                                                                                            type="radio"
                                                                                            name={`pregunta_${pregunta.id}`}
                                                                                            value={opcion.valor}
                                                                                            checked={this.state.respuestasEvaluacion[pregunta.id] === String(opcion.valor)}
                                                                                            onChange={(e) => this.handleCambioRespuesta(pregunta.id, opcion.valor)}
                                                                                        />
                                                                                        <div className="small text-muted mt-1">{opcion.texto}</div>
                                                                                    </>
                                                                                ) : null}
                                                                            </td>
                                                                        );
                                                                    })}
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        );
                                    })()}

                                    {/* Preguntas abiertas */}
                                    {this.state.preguntasEvaluacion.filter(p => p.tipo === 'Abierta' || p.tipo === 'abierta').length > 0 && (
                                        <div className="mt-4">
                                            <h6>Preguntas abiertas</h6>
                                            {this.state.preguntasEvaluacion
                                                .filter(p => p.tipo === 'Abierta' || p.tipo === 'abierta')
                                                .map((pregunta, index) => (
                                                    <FormGroup key={pregunta.id}>
                                                        <label><strong>{index + 1}. {pregunta.pregunta}</strong></label>
                                                        <textarea
                                                            className="form-control mt-2"
                                                            rows="2"
                                                            value={this.state.respuestasEvaluacion[pregunta.id] || ''}
                                                            onChange={(e) => this.handleCambioRespuesta(pregunta.id, e.target.value)}
                                                        />
                                                    </FormGroup>
                                                ))}
                                        </div>
                                    )}
                                </ModalBody>

                                <ModalFooter>
                                    <Button
                                        color="primary"
                                        onClick={this.enviarRespuestasEvaluacion}
                                        disabled={
                                            !this.state.docenteSeleccionado || !this.validarRespuestasCompletas()
                                        }
                                    >
                                        Guardar Evaluación
                                    </Button>
                                    <Button color="secondary" onClick={this.cerrarModalEvaluacion}>Cancelar</Button>
                                </ModalFooter>
                            </Modal>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
